"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalCredit = void 0;
var react_1 = __importDefault(require("react"));
var ModalCredit_module_scss_1 = __importDefault(require("./ModalCredit.module.scss"));
var CardAuto_1 = require("../cardAuto/CardAuto");
var FormCredit_1 = require("../formCredit/FormCredit");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var Svg_1 = require("../svg/Svg");
var useCreditForm_1 = require("../../hook/useCreditForm");
var benefits = ['Гарантия 1 год', 'Скидка до 300 000', 'Первый взнос от 0%', 'Трейд-ин как первый взнос'];
var ModalCredit = function () {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var car = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.car.carSelect;
    var modalCreditState = (0, react_redux_1.useSelector)(selectors_1.modalSelector).credit.modalState;
    var _b = (0, useCreditForm_1.useCreditForm)(), register = _b.register, errors = _b.errors, onSubmit = _b.onSubmit, handleSubmit = _b.handleSubmit, sliderField = _b.sliderField, setValue = _b.setValue, payment = _b.payment;
    var closeHandler = function () {
        dispatch((0, modalSlice_1.closeModal)('credit'));
    };
    var handleFormSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, onSubmit(data)];
                case 1:
                    _a.sent();
                    closeHandler(); // Закрываем модальное окно после успешной отправки
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Ошибка отправки формы:', error_1);
                    alert('Не удалось отправить заявку. Попробуйте ещё раз.');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "".concat(ModalCredit_module_scss_1.default.modal_credit, " ").concat(modalCreditState ? ModalCredit_module_scss_1.default.modal_credit_active : ''), onClick: closeHandler, onTransitionEnd: function () {
            if (!modalCreditState) {
                // Дополнительная логика после закрытия
            }
        } },
        react_1.default.createElement("div", { className: ModalCredit_module_scss_1.default.modal_credit__inner, onClick: function (event) { return event.stopPropagation(); } },
            react_1.default.createElement("header", { className: ModalCredit_module_scss_1.default.modal_credit__header },
                react_1.default.createElement("h3", { className: ModalCredit_module_scss_1.default.modal_credit__title }, "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442"),
                react_1.default.createElement("h4", null,
                    (car === null || car === void 0 ? void 0 : car.brand)
                        ? typeof car.brand === 'string'
                            ? car.brand
                            : car.brand.name
                        : 'Неизвестный бренд',
                    ((_a = car === null || car === void 0 ? void 0 : car.model) === null || _a === void 0 ? void 0 : _a.name) ? " ".concat(car.model.name) : ' Неизвестная модель',
                    (car === null || car === void 0 ? void 0 : car.year) ? " ".concat(car.year, " \u0433.") : ''),
                react_1.default.createElement(Svg_1.Cross, { className: ModalCredit_module_scss_1.default.modal_credit__cross, handler: closeHandler })),
            react_1.default.createElement("div", { className: ModalCredit_module_scss_1.default.modal_credit__content },
                react_1.default.createElement("section", { className: ModalCredit_module_scss_1.default.modal_credit__benefits }, benefits.map(function (benefit) {
                    return (react_1.default.createElement("article", { className: ModalCredit_module_scss_1.default.modal_credit__benefits_item, key: benefit }, benefit));
                })),
                react_1.default.createElement("section", { className: ModalCredit_module_scss_1.default.modal_credit__application },
                    react_1.default.createElement(FormCredit_1.FormCredit, __assign({}, {
                        register: register,
                        errors: errors,
                        handleSubmit: handleSubmit,
                        onSubmit: handleFormSubmit,
                        sliderField: sliderField,
                        setValue: setValue,
                        payment: payment,
                    })),
                    car.id ? (react_1.default.createElement(CardAuto_1.CardAuto, __assign({}, car, { extraClassName: ModalCredit_module_scss_1.default.modal_credit__card_car, inModalCredit: true }))) : null)))));
};
exports.ModalCredit = ModalCredit;
